import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import { TOOL_NAMES } from 'js/src/agent/toolNames';
import type { Skill } from '../types';

export const layeredGraphicsBasicsSkill: Skill = {
    name: SKILL_NAMES.layeredGraphicsBasics,
    description:
        'A bespoke animated graphic layered over a scene that already shows something — footage, a ' +
        'talking head or avatar, a stock design — on a transparent layer, so what is beneath stays ' +
        'on screen. Load BEFORE adding or changing one.',
    kind: 'howto',
    surfaces: ['sketch'],
    get instructions(): string {
        return `# Layered Graphics

A layered graphic is a motion graphics composition on a transparent layer above a scene that
already shows something. What is beneath stays on screen; the graphic adds to it.

## When to reach for one
When a drawn element would help the viewer follow what is said — a figure, a short sequence of
steps, a comparison, a chart — while the speaker, footage or design stays on screen. A stock design
can carry a short line of words; a layered graphic shows the idea itself. A graphic that would
replace everything beneath belongs in a motion graphics scene of its own.

Give each one idea, anchored on the words that state it.

## Adding or changing one
\`${TOOL_NAMES.designGraphic}\` on the scene with a brief. A designer authors the graphic over what
the scene shows; you do not write its HTML. Call it again on the same scene to change the graphic,
with a brief that says what to change. The graphic spans the scene it is on.
- **Over a talking head or avatar,** the base scene spans the whole recording, so first give the
  graphic its own span: \`${TOOL_NAMES.addVoiceoverScene}\` with the base scene's scene_id as its
  \`scene_design_id\`, naming the words. That overlay shows the speaker as the base does; design the
  graphic on it. List it in the same call as the group's other overlays.
- **Over a stock design,** the design's own copy stays on screen: clear the text the graphic
  replaces with \`${TOOL_NAMES.setText}\` first.

## The brief
The designer sees the scene, its narration and the video's look, but not this conversation. Give it
the idea to show, the exact figures, names or steps, and the words each part lands on. Leave the
visual treatment to it.`;
    },
};
